import styled from 'styled-components';

import { colors } from 'theme';

import { ButtonWithStyles } from './ButtonWithStyles';

export const LegacySecondaryButton = styled(ButtonWithStyles)`
  ${({ reverse, width }) => `
      color: ${reverse ? colors.white : colors.waterBlue};
      width: ${width};
      border: 1px solid ${reverse ? colors.white : colors.waterBlue};
      &:not([disabled]):hover {
        background-color: ${colors.softBlue};
        text-decoration: none;
      }
    `}
`;
